/*
Copyright (C) 2026  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import Api from "@src/utils/ApiCaller";
import configLoader from "@src/utils/Config";

import type { PrerequisitesResult } from "@src/@types/WizardData";

const actionUrl = (endpointId: string) =>
  `${configLoader.config.servicesUrls.coriolis}/${Api.projectId}/endpoints/${endpointId}/actions`;

class PrerequisitesSource {
  async check(opts: {
    endpointId: string;
    env: any;
    instance: { num_cpu: number; memory_mb: number };
  }): Promise<PrerequisitesResult> {
    const response = await Api.send({
      url: actionUrl(opts.endpointId),
      method: "POST",
      data: {
        "target-prerequisites": { action: "check", env: opts.env, instance: opts.instance },
      },
      timeout: 170000,
    });
    return response.data["target-prerequisites"];
  }

  async create(opts: {
    endpointId: string;
    env: any;
    item: string;
    options?: { [key: string]: string };
  }): Promise<{ created: string; detail: string }> {
    const response = await Api.send({
      url: actionUrl(opts.endpointId),
      method: "POST",
      data: {
        "target-prerequisites": {
          action: "create",
          item: opts.item,
          env: opts.env,
          options: opts.options || {},
        },
      },
      timeout: 170000,
    });
    return response.data["target-prerequisites"];
  }
}

export default new PrerequisitesSource();
